import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import { Row, Col } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import logo from "../../Assets/images/TRANSPARENT-07.png";
import rightArrow from "../../Assets/icons/arrow-right.png";
import { useNavigate } from "react-router-dom";
const Header = () => {
  const navigate = useNavigate();

  let count;
  if (localStorage.getItem("cartItems")) {
    count = JSON.parse(localStorage.getItem("cartItems"));
  }

  const HandleAccount = () => {
    if (localStorage.getItem("token")) {
      navigate("/order_summary");
    } else {
      navigate("/login");
    }
  };

  const handleproduct = (e) => {
    navigate(`/product/${e.target.id}`);
  };

  return (
    <div className="header_wrapper" id="top">
      <div className="upper_navigation_bar darkblue_bg">
        <Navbar className="py-0">
          <Container>
            <Row className="w-100 m-auto">
              <Col xxl="6" xl="8" md="8">
                <Navbar.Collapse className="justify-content-start">
                  <Navbar.Text className="me-5">
                    <a href="/">Proudly Serving America</a>
                  </Navbar.Text>
                  <Navbar.Text className="me-5">
                    <a href="/">24/7 Live Chat Available</a>
                  </Navbar.Text>
                  <Navbar.Text className="me-5">
                    <a href="tel: +1 (833) 465 0300">Call Us! (833) 465 0300</a>
                  </Navbar.Text>
                </Navbar.Collapse>
              </Col>
              <Col xxl="6" xl="4" md="4">
                <Navbar.Collapse className=" header_content justify-content-end">
                  <Navbar.Text
                    className="me-5 cursor_pointer header_btns"
                    onClick={HandleAccount}
                  >
                    My Account
                  </Navbar.Text>
                  <Navbar.Text
                    className="me-5 cursor_pointer header_btns"
                    onClick={() => navigate("/cart")}
                  >
                    Cart
                    <span className="badge badge-danger mx-1">
                      {count && count.length > 0 ? count.length : ""}
                    </span>
                  </Navbar.Text>
                  <Navbar.Text
                    className={
                      localStorage.getItem("token")
                        ? "cursor_pointer me-5"
                        : "cursor_pointer"
                    }
                    onClick={() => navigate("/support")}
                  >
                    Support
                  </Navbar.Text>
                  {localStorage.getItem("token") ? (
                    <Navbar.Text
                      className="cursor_pointer"
                      onClick={() => {
                        localStorage.removeItem("userData");
                        localStorage.removeItem("token");
                        localStorage.removeItem("Usercart");
                        localStorage.removeItem("cartItems");
                        localStorage.removeItem("addedProducts");
                        navigate("/");
                      }}
                    >
                      Log Out
                    </Navbar.Text>
                  ) : (
                    ""
                  )}
                </Navbar.Collapse>
              </Col>
            </Row>
          </Container>
        </Navbar>
      </div>
      <div className="main_navbar">
        <Navbar collapseOnSelect expand="lg">
          <Container>
            <Navbar.Brand>
              <img
                src={logo}
                alt="logo"
                className="cursor_pointer"
                onClick={() => navigate("/")}
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse
              id="responsive-navbar-nav"
              className="justify-content-end align-items-center h-100"
            >
              <Nav className="justify-content-end align-items-center w-100">
                <NavDropdown
                  title="Microsoft Office"
                  id="collasible-nav-dropdown"
                >
                  <Navbar.Text className="parent_nav blue_bg px-3">
                    <b>Office 2021</b>
                  </Navbar.Text>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    onClick={handleproduct}
                    id="Office2021HomeandStudent"
                    className="blue_text"
                  >
                    Office 2021 Home & Student
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={handleproduct}
                    id="Office2021HomeandBusiness"
                    className="blue_text"
                  >
                    Office 2021 Home & Business
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={handleproduct}
                    id="Office2021Professional"
                    className="blue_text"
                  >
                    Office 2021 Professional
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <Navbar.Text className="parent_nav blue_bg px-3">
                    <b>Office 2019</b>
                  </Navbar.Text>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    id="Office2019HomeandStudent"
                    onClick={handleproduct}
                    className="blue_text"
                  >
                    Office 2019 Home & Student
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={handleproduct}
                    id="Office2019HomeandBusiness"
                    className="blue_text"
                  >
                    Office 2019 Home & Business
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={handleproduct}
                    id="Office2019Professional"
                    className="blue_text"
                  >
                    Office 2019 Professional
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <Navbar.Text className="parent_nav blue_bg px-3">
                    <b>Office 2016</b>
                  </Navbar.Text>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    onClick={handleproduct}
                    id="Office2016HomeandStudent"
                    className="blue_text"
                  >
                    Office 2016 Home & Student
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={handleproduct}
                    className="blue_text"
                    id="Office2016HomeandBusiness"
                  >
                    Office 2016 Home & Business
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={handleproduct}
                    id="Office2016Professional"
                    className="blue_text"
                  >
                    Office 2016 Professional
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <Navbar.Text
                    className="parent_nav red_bg px-3 text-white"
                    onClick={() => navigate("/category/MicrosoftOffice")}
                  >
                    <NavDropdown.Item className="p-0">
                      <b className="me-2">Shop Office</b>
                      <img src={rightArrow} alt="arrow" />
                    </NavDropdown.Item>
                  </Navbar.Text>
                </NavDropdown>
                <NavDropdown
                  title="Office for Mac"
                  id="collasible-nav-dropdown"
                  className="mx-5"
                >
                  <Navbar.Text className="parent_nav blue_bg px-3">
                    <b>Office 2021 (For Mac)</b>
                  </Navbar.Text>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    onClick={handleproduct}
                    className="blue_text"
                    id="Office2021HomeandStudentForMAC"
                  >
                    Office 2021 Home & Student
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={handleproduct}
                    className="blue_text"
                    id="Office2021HomeandBusinessForMAC"
                  >
                    Office 2021 Home & Business
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <Navbar.Text className="parent_nav blue_bg px-3">
                    <b>Office 2019 (For Mac)</b>
                  </Navbar.Text>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    onClick={handleproduct}
                    className="blue_text"
                    id="Office2019HomeandStudentForMAC"
                  >
                    Office 2019 Home & Student
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={handleproduct}
                    className="blue_text"
                    id="Office2019HomeandBusinessForMAC"
                  >
                    Office 2019 Home & Business
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <Navbar.Text className="parent_nav blue_bg px-3">
                    <b>Office 2016 (For Mac)</b>
                  </Navbar.Text>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    onClick={handleproduct}
                    className="blue_text"
                    id="Office2016HomeandStudentForMac"
                  >
                    Office 2016 Home & Student
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={handleproduct}
                    className="blue_text"
                    id="Office2016HomeandBusinessForMac"
                  >
                    Office 2016 Home & Business
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <Navbar.Text
                    className="parent_nav red_bg px-3 text-white"
                    onClick={() => navigate("/category/OfficeForMac")}
                  >
                    <NavDropdown.Item className="p-0">
                      <b className="me-2">Shop Office (For Mac)</b>
                      <img src={rightArrow} alt="arrow" />
                    </NavDropdown.Item>
                  </Navbar.Text>
                </NavDropdown>
                <NavDropdown
                  title="Window Operating Systems"
                  id="collasible-nav-dropdown"
                >
                  <Navbar.Text className="parent_nav blue_bg px-3">
                    <b>Windows 11</b>
                  </Navbar.Text>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    onClick={handleproduct}
                    id="Windows11Home"
                    className="blue_text"
                  >
                    Windows 11 Home
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={handleproduct}
                    id="Windows11Professional"
                    className="blue_text"
                  >
                    Windows 11 Professional
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <Navbar.Text className="parent_nav blue_bg px-3">
                    <b>Windows 10</b>
                  </Navbar.Text>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    onClick={handleproduct}
                    id="Windows10Home"
                    className="blue_text"
                  >
                    Windows 10 Home
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={handleproduct}
                    id="Windows10Professional"
                    className="blue_text"
                  >
                    Windows 10 Professional
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <Navbar.Text className="parent_nav blue_bg px-3">
                    <b>Windows 8.1</b>
                  </Navbar.Text>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    onClick={handleproduct}
                    id="Windows8.1Professional"
                    className="blue_text"
                  >
                    Windows 8.1 Professional
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <Navbar.Text
                    className="parent_nav red_bg px-3 text-white"
                    onClick={() => navigate("/category/WindowsOperatingSystem")}
                  >
                    <NavDropdown.Item className="p-0">
                      <b className="me-2">Shop Windows</b>
                      <img src={rightArrow} alt="arrow" />
                    </NavDropdown.Item>
                  </Navbar.Text>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </div>
  );
};

export default Header;
